import { createTheme } from '@mui/material/styles';

export const calendarDateTheme = createTheme({
  components: {
    MuiGrid: {
      defaultProps: {
        height: '4rem',
        color: undefined as string | undefined,
        border: '1px solid',
        borderColor: '#82888a',
        display: 'inline-flex',
        borderRadius: '15%',
        marginBottom: '0.5rem',
        marginLeft: '0.045rem',
        fontSize: '8px',
        paddingLeft: '03px',
      },
    },
  },
});
